import { useAppSelector } from "../app/hooks";
import Trade from "./trade";
import { selectImageSrc } from "../features/image";
import Price from "./price";
import InvitationCode from "./invitation-code/invitationCode";

export type CardProps = {
  renderImg: boolean;
};
const Card = () => {
  const imageSrc: string = useAppSelector(selectImageSrc);

  return (
    <div className=" select-none flex flex-col items-center justify-center w-full h-full">
      {/* <InviteCode /> */}

      <div className="select-none w-11/12 md:w-fit flex gap-5 flex-col md:flex-row items-start md:items-center justify-center md:h-[360px]">
        <div
          className="select-none w-full md:w-fit  md:h-full flex flex-col items-center gap-5 md:gap-12  
         bg-gray-900 bg-opacity-70 p-2 md:p-4 md:px-16 rounded-2xl"
        >
          {/* <RewardHistory /> */}
          <Price />
          {<Trade></Trade>}
        </div>
        <InvitationCode />
      </div>
    </div>
  );
};
export default Card;
